import _isEmpty from 'lodash/isEmpty';

export default ({ user = {} }) => {
  const uid = !_isEmpty(user.uid) ? user.uid : 'User';
  if (user.uid.includes('|')) {
    return user.uid.split('|')[1];
  }
  return uid;
};
